import React, { Component } from "react";
// import get from "lodash/get";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import Presenter from "../../../../user/model/presenter.js";
import PermissionProperties from "../../../../config/permission.js";
import ModalHelper from "../../../../user/model/helper/modal.js";
import FormHelper from "../../../../user/model/helper/form.js";
import MessageProperties from "../../../../config/message.js";
import RequestProperties from "../../../../user/model/helper/request.props.js";
import SelectQuery from "component/SelectQuery.js";
import Request from "config/Request";
import { toast } from "react-toastify";
import { StoreUserInfoFromMobile, UpdateUserInformation } from "user/action";
import "react-toastify/dist/ReactToastify.min.css";
import handlingError from 'utils/handlingError.js'
import windowStop from "../../../../utils/windowStop.js";
import Lib from 'utils/Lib';
const HEIGHT_PHOTO = 300, WIDTH_PHOTO = 300;
const noProfileImg = "../img/no-profile.jpg";
const { ReactNativeWebView } = window;

// const WaitingUpload = new Promise(
//   (resolve, reject) => {
//     resolve('success')
//     reject(new Error('rejected'))  
//   }
// )

class UserSettingsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Props: this.setFields(props.UserReducer),
      Cridential: {
        modal: false,
        OldPassword: "",
        NewPassword: "",
        ReNewPassword: "",
      },
      disabledPhotoButton: true,
      disabledPhotoFile: false,
      thumbPhoto: props.UserReducer.props.photo
    };

    this.__ToogleResetPasswordModal__ = this.__ToogleResetPasswordModal__.bind(this);
    this.handleMobile = this.handleMobile.bind(this);
    this.handleChangePhoto = this.handleChangePhoto.bind(this);
    this.onUploadPhotoSuccess = this.onUploadPhotoSuccess.bind(this);
    this.onUploadPhotoFailed = this.onUploadPhotoFailed.bind(this);
    this.formData = new FormData();
    this.file = null;
    this.payload = {};
  }
  __ToogleResetPasswordModal__() {
    this.setState({
      Cridential: {
        ...this.state.Cridential,
        modal: !this.state.Cridential.modal
      }
    })
  }
  __OnSaveSuccess__(self, response) {
    self.props.RunRedux(
      UpdateUserInformation({
        first_name: response.FirstName,
        last_name: response.LastName,
        tag: response.Tag,
        phone: response.Phone,
        email: response.Email,
        address1: response.Address,
        address2: response.Address2,
        city: response.City,
        postal: response.Postal,
        emailNotif: response.EmailNotif,
        nextOfKin: response.NextOfKin,
        phoneNo: response.PhoneNo,
        photo: response.Photo,
        is_lite : response.tenant.is_lite
      })
    )
    toast.success(MessageProperties.SUCEESS.MODEL.USER.SELF_UPDATE);
    if (ReactNativeWebView) {
      ReactNativeWebView.postMessage(
        JSON.stringify(self.props.UserReducer.props)
      );
    }
  }
  __OnFailed__(error) {
    handlingError(error)
  }
  __SaveProps__(self) {
    if (!FormHelper.ValidateForm(self.state.Props, MessageProperties)) {
      return;
    }
    Presenter.UpdateSelfInformation(
      RequestProperties.UpdateSelfProps(
        self.__OnSaveSuccess__,
        self.__OnFailed__,
        PermissionProperties.USER.USER.UPDATE,
        self
      )
    );
  } //Update Password
  __OnUpdatePasswordSuccess__(self, params) {
    toast.success(MessageProperties.SUCEESS.MODEL.USER.PASSWORD_UPDATE);
    self.setState({
      Cridential: {
        modal: false,
        OldPassword: "",
        NewPassword: "",
        ReNewPassword: ""
      }
    });
  }
  __UpdatePassword__(self) {
    if (!FormHelper.ValidateResetPasswordForm(self.state.Cridential, MessageProperties)) {
      return;
    }

    Presenter.UpdatePassword(
      RequestProperties.ResetPasswordProps(
        self.__OnUpdatePasswordSuccess__,
        self.__OnFailed__,
        PermissionProperties.USER.USER.UPDATE,
        self
      )
    );
  }

  resetPhoto() {
    this.formData = new FormData();
    this._photo.value = null;
  }

  getPhoto(url) {
    if (!url || url === "") {
      return noProfileImg;
    } else {
      return url;
    }
  }

  readImage(_file) {
    var fr = new FileReader();
    let file = _file.files[0];

    if (file && file.type.match("image.*")) {
      fr.onload = () => {
        var img = new Image();

        img.onload = () => {
          var w = img.width;
          var h = img.height;

          if (w < WIDTH_PHOTO || h < HEIGHT_PHOTO) {
            alert(
              "image width must be " +
                WIDTH_PHOTO +
                "px & height must be " +
                HEIGHT_PHOTO +
                "px"
            );
            this.resetPhoto();
            this.disableButton(true, false);
            return;
          } else {
            this.setState({
              thumbPhoto: URL.createObjectURL(file)
            });
          }
        };
        img.src = fr.result;
      };
      fr.readAsDataURL(file);
    } else if (file && !file.type.match("image.*")) {
      alert("Invalid file type, only support image");
      this.resetPhoto();
      this.disableButton(true, false);
    } else {
      this.setState({ disabledPhotoUpload: true });
    }
  }

  disableButton(disabledPhotoButton, disabledPhotoFile) {
    this.setState({ disabledPhotoButton, disabledPhotoFile });
  }

  handleChangePhoto(e) {
    let file = e.target.files;
    this.file = file[0];

    if(file.length > 0) {
      this.disableButton(false, false)
    } else {
      this.disableButton(true, false)
    }

    this.readImage(e.target);
  }

  uploadPhoto(withUpdate = false) {
    this.formData.append("Photo", this.file);
    Request(
      "post",
      "upload-user-photo",
      {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + this.props.UserReducer.token
      },
      this.formData,
      [],
      this.onUploadPhotoSuccess,
      this.onUploadPhotoFailed,
      { withUpdate }
    );

  }

  onUploadPhotoSuccess(response, extra) {
    toast.success("Photo has been uploaded successfully");
    this.resetPhoto()
    this.disableButton(true, false)
    if(extra.withUpdate){
      this.__SaveProps__(this);
    } else {
      this.props.RunRedux(
        UpdateUserInformation({ photo: response.data.Photo })
      );
      if (ReactNativeWebView) {
        ReactNativeWebView.postMessage(
          JSON.stringify(this.props.UserReducer.props)
        );
      }
    }
  }

  onUploadPhotoFailed(error) {
    handlingError(error)
    this.disableButton(true, false)
  }

  setFields(UserReducer) {
    return {
      Alias: UserReducer.props.alias,
      Username: UserReducer.username,
      Email: UserReducer.props.email,
      Phone: UserReducer.props.phone,
      Password: "Secret",
      FirstName: UserReducer.props.first_name,
      LastName: UserReducer.props.last_name,
      Role: UserReducer.props.role,
      Tag: UserReducer.props.tag,
      Address: UserReducer.props.address1,
      Address2: UserReducer.props.address2,
      City: Lib.getNested(UserReducer, "props.city.pk", null),
      Postal: UserReducer.props.postal,
      IsAdmin: UserReducer.props.isAdmin,
      EmailNotif: UserReducer.props.emailNotif,
      NextOfKin: UserReducer.props.nextOfKin,
      PhoneNo: UserReducer.props.phoneNo,
      Photo: UserReducer.props.photo,
      Is_lite: UserReducer.props.is_lite
    };
  }

  handleMobile({ data }) {
    let parsedData = JSON.parse(data);
    this.props.RunRedux(StoreUserInfoFromMobile(parsedData.userReducer));
    console.log(parsedData )
    this.setState({
      Props: this.setFields(this.props.UserReducer),
      thumbPhoto: this.props.UserReducer.props.photo
    });
  }

  componentDidMount() {
    if(ReactNativeWebView){
      window.addEventListener("message", this.handleMobile);
      document.addEventListener("message", this.handleMobile);
      ReactNativeWebView.postMessage("mounted");
    }
  }

  componentWillUnmount() {
    if(ReactNativeWebView){
      window.removeEventListener("message", this.handleMobile);
      document.removeEventListener("message", this.handleMobile);
    }
    windowStop()
  }

  saveAndUpload = () => {
    this.uploadPhoto(true);
  }

  renderSaveBtn() {
    const {disabledPhotoButton} = this.state
    if(!disabledPhotoButton) {
      return (<Button color="primary" onClick={() => this.saveAndUpload()}>Save & Upload</Button>)
    }else {
      return (<Button color="primary" onClick={() => this.__SaveProps__(this)}>Save</Button>)
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-body">
            <div className="container" style={{ padding: "2rem" }}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>User Name</label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      value={this.state.Props.Username}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Role</label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      value={Lib.getNested(this.state.Props, "Role.Name")}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="required">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.FirstName}
                      onChange={event =>
                        this.setState({
                          Props: {
                            ...this.state.Props,
                            FirstName: event.target.value
                          }
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="required">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.LastName}
                      onChange={event =>
                        this.setState({
                          Props: {
                            ...this.state.Props,
                            LastName: event.target.value
                          }
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                  <label className="required">Email</label>
                  <div className="input-group suffix">
                    <input
                      type="email"
                      className="form-control"
                      value={this.state.Props.Email}
                      onChange={event =>
                        this.setState({
                          Props: {
                            ...this.state.Props,
                            Email: event.target.value
                          }
                        })
                      }
                    />

                    <div className="input-group-addon email-notification">
                      <label className="spaceRRR mb0">Email Notification </label>
                      <label className="switch switch-sm switch-text switch-primary mb0">
                        <input
                          onChange={event =>
                            this.setState({
                              Props: {
                                ...this.state.Props,
                                EmailNotif: event.target.checked
                              }
                            })
                          }
                          name="emailNotif"
                          type="checkbox"
                          className="switch-input"
                          checked={this.state.Props.EmailNotif}
                        />
                        <span
                          className="switch-label"
                          data-on="On"
                          data-off="Off"
                        />
                        <span className="switch-handle" />
                      </label>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                  <label className="required">Your Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone Empty"
                    value={this.state.Props.Phone}
                    onChange={event =>
                      this.setState({
                        Props: { ...this.state.Props, Phone: event.target.value }
                      })
                    }
                  />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                  <label className="required">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.Props.Address}
                    onChange={event =>
                      this.setState({
                        Props: {
                          ...this.state.Props,
                          Address: event.target.value
                        }
                      })
                    }
                  />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                  <label className="optional">Address 2</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.Props.Address2}
                    onChange={event =>
                      this.setState({
                        Props: {
                          ...this.state.Props,
                          Address2: event.target.value
                        }
                      })
                    }
                  />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="required">City</label>
                    <SelectQuery
                      placeholder="Type City"
                      value={this.state.Props.City}
                      onChange={val =>
                        this.setState({
                          Props: { ...this.state.Props, City: val.pk }
                        })
                      }
                      urlKey="read-city-in-cov-autocomplete"
                      valKey="pk"
                      valLabel="Name"
                      initOption={this.props.UserReducer.props.city}
                      isCreatable={false}
                      UserReducer={this.props.UserReducer}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="optional">Postal</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.Postal}
                      onChange={event =>
                        this.setState({
                          Props: { ...this.state.Props, Postal: event.target.value }
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="optional">Tag</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.Tag}
                      onChange={event =>
                        this.setState({
                          Props: { ...this.state.Props, Tag: event.target.value }
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="optional">Next of Kin</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.NextOfKin}
                      onChange={event =>
                        this.setState({
                          Props: {
                            ...this.state.Props,
                            NextOfKin: event.target.value
                          }
                        })
                      }
                      placeholder="Next of Kin"
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="optional">Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Props.PhoneNo}
                      onChange={event =>
                        this.setState({
                          Props: {
                            ...this.state.Props,
                            PhoneNo: event.target.value
                          }
                        })
                      }
                      placeholder="Phone"
                    />
                  </div>
                </div>
              </div>


              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Photo</label>
                    <div className="input-group suffix">
                      <input
                        type="file"
                        className="form-control"
                        name="login-logo"
                        accept="image/*"
                        ref={ref => (this._photo = ref)}
                        onChange={this.handleChangePhoto}
                        disabled={this.state.disabledPhotoFile}
                      />
                      <span className="input-group-addon white-background no-padding">
                        <button
                          className="btn btn-link"
                          onClick={() => this.uploadPhoto()}
                          disabled={this.state.disabledPhotoButton}
                        >
                          Upload
                        </button>
                      </span>
                    </div>
                    <div className="good-tips">
                      Best Tips:
                      <ul>
                        <li>
                          Resolution : width {WIDTH_PHOTO}px - height{" "}
                          {HEIGHT_PHOTO}px{" "}
                          <small className="apple-red">(Mandatory)</small>
                        </li>
                        <li>Background : Transparent / White</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 offset-md-3">
                  <div className="form-group">
                    <div className="tenant-img-thumb __square bg-transparent-pattern">
                      <img
                        src={this.getPhoto(this.state.thumbPhoto)}
                        alt="Login Logo"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <hr />
                <div className="space-between">
                  <Button color="default" onClick={() => this.__ToogleResetPasswordModal__()}>
                    Reset Password
                  </Button>
                  {this.renderSaveBtn()}
                </div>
            </div>
          </div>

          {ModalHelper.ResetPasswordModal(this)}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    UserReducer: state.UserReducer
  }
}

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSettingsScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/user/settings.js